@if (error) {
  <div class="error-banner">
    <div>{{ error.message }}</div>
  </div>
}

<div class="main_body">

  <div class="contents contents--user-top">
    @if (inputValidationErrors.length > 0) {
      <div class="contents__section highlight">
        <p i18n="@@home.userSummary.message.uploadError">入力されたデータに以下のエラーがあるためアップロードを中止しました。修正後もう一度アップロードしてください。</p>
        @for (error of inputValidationErrors; track $index) {
          <p>- {{ error }}</p>
        }
      </div>
    }

    <div class="contents_section_group">
      <div class="package-section--3col">
        <div class="contents__section fixed-section">
          <div class="summary-panel">
            <section class="summary-panel__block summary-panel__dates">
              @if (mode === modeEnum.display) {
                <div class="dates-row dates-row--reserve-info dates-row--with-info">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@home.userSummary.label.displayData">表示データ</mat-label>
                    <input matInput id="upload_date0" (dateChange)="onUploadDateChange()" [matDatepicker]="userpicker0"
                      [value]="userDataDate0" readonly>
                    <mat-datepicker-toggle matSuffix [for]="userpicker0"></mat-datepicker-toggle>
                    <mat-datepicker #userpicker0 [dateClass]="uploadDateClass" panelClass="datepicker-with-legend"></mat-datepicker>
                  </mat-form-field>
                  <button mat-icon-button
                          class="mat-elevation-z0 info-button"
                          [matTooltip]="summaryDatesTooltip"
                          matTooltipClass="summary-dates-tooltip"
                          i18n-aria-label="@@home.userSummary.ariaLabel.dateInfo"
                          aria-label="表示/対比データの日付を表示">
                    <mat-icon fontSet="material-icons-outlined">info</mat-icon>
                  </button>
                </div>
              }

              @if (mode === modeEnum.input) {
                <div class="dates-row dates-row--reserve-info">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@home.userSummary.label.evaluationDate">評価日</mat-label>
                    <input matInput id="upload_date0" (dateChange)="onUploadDateChange()" [matDatepicker]="userpicker1"
                      [value]="uploadAsOfDate" readonly>
                    <mat-datepicker-toggle matSuffix [for]="userpicker1"></mat-datepicker-toggle>
                    <mat-datepicker #userpicker1 [dateClass]="uploadDateClass"></mat-datepicker>
                  </mat-form-field>
                </div>
              }
            </section>

            @if (mode === modeEnum.display && filteredPdfOptions && filteredPdfOptions.length > 0) {
              <section class="summary-panel__block pdf_options" [class.pdf-options--collapsed]="!isPdfOptionsExpanded">
                <div class="pdf-options-header">
                  <div class="title">
                    <span i18n="@@home.userSummary.label.pdfOptionTitle">PDF出力にGOKURIレコードを追加</span>
                  </div>
                  <button type="button"
                          class="pdf-options-toggle"
                          (click)="togglePdfOptions()"
                          [attr.aria-expanded]="isPdfOptionsExpanded">
                    @if (isPdfOptionsExpanded) {
                      <span i18n="@@home.userSummary.button.collapseOptions">オプションを閉じる</span>
                    } @else {
                      <span i18n="@@home.userSummary.button.expandOptions">オプションを表示</span>
                    }
                    @if (!isPdfOptionsExpanded) {
                      <span class="pdf-options-toggle__summary">
                        （{{ getPdfOptionsSummaryLabel() }}）
                      </span>
                    }
                    <mat-icon fontSet="material-icons-outlined">
                      {{ isPdfOptionsExpanded ? 'expand_less' : 'expand_more' }}
                    </mat-icon>
                  </button>
                </div>
                @if (isPdfOptionsExpanded) {
                  <div class="pdf-options-list">
                    @for (option of filteredPdfOptions; track option.label) {
                      <label>
                        <input type="checkbox" [(ngModel)]="option.checked" [name]="option.label" (change)="onPdfOptionsCheckboxChange()" />
                        {{ option.label }}
                      </label>
                    }
                  </div>
                }
              </section>
            } @else if (mode === modeEnum.input) {
              <section class="summary-panel__block pdf_options">
                <div class="edit-actions-header">
                  <div class="title">
                    <span i18n="@@home.userSummary.label.dateAdjustment">日付の調整</span>
                  </div>
                </div>
                <div class="date-segmented-group" role="group"
                     aria-label="日付の調整" i18n-aria-label="@@home.userSummary.ariaLabel.dateAdjustment">
                  <button type="button" (click)="setToPrevDay()"
                    aria-label="前の日に戻す" i18n-aria-label="@@home.userSummary.ariaLabel.prevDay"
                    class="date-segmented-btn">
                    <mat-icon fontSet="material-icons-outlined">chevron_left</mat-icon>
                    <span i18n="@@home.userSummary.button.previousDay">前日</span>
                  </button>
                  <button type="button" (click)="setToToday()"
                    aria-label="今日の日付に戻す" i18n-aria-label="@@home.userSummary.ariaLabel.toToday"
                    class="date-segmented-btn date-segmented-btn--today">
                    <mat-icon fontSet="material-icons-outlined">calendar_today</mat-icon>
                    <span i18n="@@home.userSummary.button.today">今日</span>
                  </button>
                  <button type="button" (click)="setToNextDay()"
                    aria-label="次の日に進める" i18n-aria-label="@@home.userSummary.ariaLabel.nextDay"
                    class="date-segmented-btn date-segmented-btn--next">
                    <mat-icon fontSet="material-icons-outlined">chevron_right</mat-icon>
                    <span i18n="@@home.userSummary.button.nextDay">次日</span>
                  </button>
                </div>
              </section>
            }

            <section class="summary-panel__block summary-panel__actions">
              <div class="button-container" [class.button-container--input]="mode === modeEnum.input">
                @if (mode === modeEnum.display) {
                  <button mat-flat-button (click)="downloadPdf()" [disabled]="isDownloadPdfButtonDisabled"
                    color="primary"
                    aria-label="PDF出力" i18n-aria-label="@@home.userSummary.ariaLabel.pdfOutput">
                    <mat-icon fontSet="material-icons-outlined">picture_as_pdf</mat-icon>
                    <span class="full-text" i18n="@@home.userSummary.button.pdfOutput">PDF出力</span>
                  </button>
                  <button mat-stroked-button (click)="changeToInputMode()" color="primary"
                    aria-label="データ入力" i18n-aria-label="@@home.userSummary.ariaLabel.dataInput">
                    <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
                    <span class="full-text" i18n="@@home.userSummary.button.dataInput">データ入力</span>
                  </button>
                }
                @if (mode === modeEnum.input) {
                  <button mat-flat-button (click)="uploadUserData()" color="primary"
                    [disabled]="isSaving()"
                    aria-label="保存" i18n-aria-label="@@home.userSummary.ariaLabel.save">
                    @if (isSaving()) {
                      <mat-spinner diameter="18" class="save-spinner"></mat-spinner>
                    } @else {
                      <mat-icon fontSet="material-icons-outlined">save</mat-icon>
                    }
                    <span class="full-text" i18n="@@home.userSummary.button.save">保存</span>
                  </button>
                  <button mat-stroked-button (click)="changeToDisplayMode()"
                    [disabled]="isSaving()"
                    aria-label="キャンセル" i18n-aria-label="@@home.userSummary.ariaLabel.cancel">
                    <mat-icon fontSet="material-icons-outlined">close</mat-icon>
                    <span class="full-text" i18n="@@home.userSummary.button.cancel">キャンセル</span>
                  </button>
                }
              </div>
            </section>
          </div>
        </div>
        @if (isLoading()) {
          <div class="contents__section">
            <app-dl-skeleton [rows]="4" />
          </div>
          <div class="contents__section">
            <app-dl-skeleton [rows]="4" />
          </div>
        }
        @for (userDataGroup of selectedSectionGroupUserDataAttributes; track userDataGroup.name) {
          @if (userDataGroup.visualizationType === 'Table' && userDataGroup.visualizationSubType === 'SmallCard') {
            <div class="contents__section">
              <div class="title">
                <span>{{ common.getDispName(userDataGroup) }}</span>
                <div class="description">
                  <span>{{ common.getDispName(userDataGroup.description) }}</span>
                </div>
              </div>
              <div class="data-columns">
                <div class="data-columns__item">
                  <div [class]="'dl-table ' + getLabelSizeClass(userDataGroup)">
                    <dl>
                      @for (dataItem of userDataGroup.dataItems; track dataItem.name) {
                        @if (dataItem.enabled) {
                          <dt class="dl-table__profile-text" [class.flex-basis-20]="dataItem.type === 'Text'">
                            @if (dataItem.type === 'PersonName') {
                              <mat-icon fontSet="material-icons-outlined">person_outline</mat-icon>
                            }
                            @if (dataItem.type === 'Date') {
                              <mat-icon fontSet="material-icons-outlined">event</mat-icon>
                            }
                            <span>{{ common.getDispName(dataItem) }}</span>
                            @if (mode === modeEnum.input && dataItem.required === true) {
                              <span class="required-mark">*</span>
                            }
                          </dt>

                          @if (mode === modeEnum.display) {
                            <dd class="value" [class.flex-basis-80]="dataItem.type === 'Text'">
                              @if (dataItem.type === 'Text') {
                                <span class="value-text"
                                  [class.value-text--clamped]="!expandedFields()[dataItem.name]"
                                  [attr.data-field]="dataItem.name">{{getUserDataItemValue(dataItem.name, userDataId0)}}</span>
                                @if (overflowingFields().has(dataItem.name)) {
                                  <button class="value-text__toggle" (click)="toggleFieldExpand(dataItem.name)">
                                    {{ expandedFields()[dataItem.name] ? i18n.button.close : i18n.button.showMore }}
                                  </button>
                                }
                              } @else {
                                {{ getUserDataItemValue(dataItem.name, userDataId0) }}
                              }
                            </dd>
                          }

                          @if (mode === modeEnum.input) {
                            <dd class="value" [class.flex-basis-80]="dataItem.type === 'Text'">
                              @if (dataItem.type === 'PersonName') {
                                <input class="user_summary_matInput" type="text" id="{{dataItem.name}}"
                                  [attr.aria-label]="common.getDispName(dataItem)"
                                  [value]="getUserDataItemValue(dataItem.name, userDataId0)"
                                  autocomplete="off"
                                  (input)="onAutoInputChange($event.target.value, dataItem)"
                                  (focus)="onAutoInputChange($event.target.value, dataItem)"
                                  [matAutocomplete]="personNameAuto">
                                <mat-autocomplete #personNameAuto="matAutocomplete">
                                  @for (option of filteredStaffOptions[dataItem.name] || []; track option) {
                                    <mat-option [value]="option" matTooltip="{{ option }}" matTooltipPosition="right"
                                      matTooltipShowDelay="1000" matTooltipHideDelay="0">
                                      <span class="autocomplete-option-text">{{ option }}</span>
                                    </mat-option>
                                  }
                                </mat-autocomplete>
                              }

                              @if (dataItem.type === 'String') {
                                <input class="user_summary_matInput" type="text" id="{{dataItem.name}}"
                                  [attr.aria-label]="common.getDispName(dataItem)"
                                  autocomplete="off"
                                  [value]="getUserDataItemValue(dataItem.name, userDataId0)">
                              }

                              @if (dataItem.type === 'Text') {
                                <div class="textarea-container">
                                  <textarea class="user_summary_matInput textarea flex-basis-80" type="text"
                                    id="{{dataItem.name}}"
                                    [attr.aria-label]="common.getDispName(dataItem)"
                                    value="{{getUserDataItemValue(dataItem.name, userDataId0)}}"
                                    rows="5"></textarea>
                                </div>
                              }

                              @if (dataItem.type === 'Int') {
                                <input class="user_summary_matInput" type="number" step="1" id="{{dataItem.name}}"
                                  [attr.aria-label]="common.getDispName(dataItem)"
                                  name="{{dataItem.name}}" placeholder="{{dataItem.min}}〜{{dataItem.max}}"
                                  value="{{getUserDataItemValue(dataItem.name, userDataId0)}}">
                              }

                              @if (dataItem.type === 'Date') {
                                <div class="input-datepicker-container">
                                  <input id="{{dataItem.name}}" class="user_summary_matInput"
                                    [attr.aria-label]="common.getDispName(dataItem)"
                                    [matDatepicker]="userpicker2"
                                    [value]="getFormattedDate(getUserDataItemValue(dataItem.name, userDataId0),'yyyy-mm-dd')"
                                    readonly (click)="userpicker2.open()">
                                  <mat-datepicker-toggle matSuffix [for]="userpicker2" class="custom-icon">
                                    <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                                  </mat-datepicker-toggle>
                                  <mat-datepicker #userpicker2></mat-datepicker>
                                </div>
                              }

                              @if (dataItem.type === 'Bool') {
                                <select id="{{dataItem.name}}" class="input_select"
                                  [attr.aria-label]="common.getDispName(dataItem)">
                                  @if (getUserDataItemValue(dataItem.name, userDataId0).length === 0) {
                                    <option value="" disabled selected i18n="@@home.userSummary.option.notSelected">未選択</option>
                                    <option value="true" i18n="@@home.userSummary.option.yes">あり</option>
                                    <option value="false" i18n="@@home.userSummary.option.no">なし</option>
                                  } @else if (getUserDataItemValue(dataItem.name, userDataId0) === 'あり') {
                                    <option value="true" selected i18n="@@home.userSummary.option.yes">あり</option>
                                    <option value="false" i18n="@@home.userSummary.option.no">なし</option>
                                  } @else {
                                    <option value="true" i18n="@@home.userSummary.option.yes">あり</option>
                                    <option value="false" selected i18n="@@home.userSummary.option.no">なし</option>
                                  }
                                </select>
                              }

                              @if (dataItem.type === 'List') {
                                <select id="{{dataItem.name}}" class="input_select"
                                  [attr.aria-label]="common.getDispName(dataItem)">
                                  @if (getUserDataItemValue(dataItem.name, userDataId0).length !== 0) {
                                    <option value="" i18n="@@home.userSummary.option.notSelected">未選択</option>
                                  } @else {
                                    <option value="" selected i18n="@@home.userSummary.option.notSelected">未選択</option>
                                  }
                                  @for (item of dataItem.values; track item) {
                                    @if (common.doesListLabelMatch( item, getUserDataItemValue(dataItem.name, userDataId0))) {
                                      <option value="{{ common.getListItemValue(item) }}" selected>
                                        {{ common.getDispName(item) }}
                                      </option>
                                    } @else {
                                      <option value="{{ common.getListItemValue(item) }}">
                                        {{ common.getDispName(item) }}
                                      </option>
                                    }
                                  }
                                </select>
                              }
                            </dd>
                          }
                        }
                      }
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          }
        }
      </div>

      <!-- メインユーザーサマリーセクション -->
      @if (isLoading()) {
        <section class="contents__section">
          <app-dl-skeleton [rows]="6" />
        </section>
        <section class="contents__section">
          <app-dl-skeleton />
        </section>
      }
      @for (userDataGroup of selectedSectionGroupUserDataAttributes; track userDataGroup.name) {
        @if ((userDataGroup.visualizationType === 'Table' &&  userDataGroup.visualizationSubType === 'WideCard') || userDataGroup.visualizationType === 'RadarChart'  ) {
          @if (userDataGroup.name !== 'basic' && userDataGroup.name !== 'comment' && userDataGroup.name !== 'KTChart') {
            <section class="contents__section">
                  <div class="user-profile">
                    <div class="user-profile__inner">
                      <div class="title">
                        <span>{{ common.getDispName(userDataGroup) }}</span>
                        <div class="description">
                          <span>{{ common.getDispName(userDataGroup.description) }}</span>
                        </div>
                      </div>
                      <div class="data-columns">
                        <div class="data-columns__item">
                          <div [class]="'dl-table dl-table--3col ' + getLabelSizeClass(userDataGroup)">
                            <dl class="column_table">
                              @for (dataItem of userDataGroup.dataItems; track dataItem.name) {
                                @if (dataItem.enabled) {

                                  <!-- 項目名 -->
                                    <dt class="dl-table__profile-text" [class.flex-basis-20]="dataItem.type === 'Text'">
                                      @if (dataItem.type === 'PersonName' ) {
                                        <mat-icon fontSet="material-icons-outlined">person_outline</mat-icon>
                                      }
                                      @if (dataItem.type === 'Date' ) {
                                        <mat-icon fontSet="material-icons-outlined">event</mat-icon>
                                      }
                                      <span>{{ common.getDispName(dataItem) }}</span>
                                      @if (mode === modeEnum.input && dataItem.required === true) {
                                        <span class="required-mark">*</span>
                                      }
                                    </dt>

                                    <!-- 表示モードのときは値を表示 -->
                                    @if (mode === modeEnum.display) {
                                      <dd class="value" [class.flex-basis-80]="dataItem.type === 'Text'">
                                        @if (dataItem.type === 'Text') {
                                          <span class="value-text"
                                            [class.value-text--clamped]="!expandedFields()[dataItem.name]"
                                            [attr.data-field]="dataItem.name">{{getUserDataItemValue(dataItem.name, userDataId0)}}</span>
                                          @if (overflowingFields().has(dataItem.name)) {
                                            <button class="value-text__toggle" (click)="toggleFieldExpand(dataItem.name)">
                                              {{ expandedFields()[dataItem.name] ? i18n.button.close : i18n.button.showMore }}
                                            </button>
                                          }
                                        } @else {
                                          {{getUserDataItemValue(dataItem.name, userDataId0)}}
                                        }
                                      </dd>
                                    }

                                    <!-- 入力モードのときはTypeに応じた入力フィールドを表示 -->
                                    @if (mode === modeEnum.input) {
                                      <dd class="value" [class.flex-basis-80]="dataItem.type === 'Text'">


                                        <!-- 人名 / テキストボックスを表示 -->
                                        @if (dataItem.type === 'PersonName' ) {
                                          <input class="user_summary_matInput" type="text" id="{{dataItem.name}}"
                                            [attr.aria-label]="common.getDispName(dataItem)"
                                            [value]="getUserDataItemValue(dataItem.name, userDataId0)"
                                            autocomplete="off"
                                            (input)="onAutoInputChange($event.target.value, dataItem)"
                                            (focus)="onAutoInputChange($event.target.value, dataItem)"
                                            [matAutocomplete]="personNameAutoTable">
                                        <mat-autocomplete #personNameAutoTable="matAutocomplete">
                                          @for (option of filteredStaffOptions[dataItem.name] || []; track option) {
                                            <mat-option [value]="option" matTooltip="{{ option }}"
                                              matTooltipPosition="right" matTooltipShowDelay="1000"
                                              matTooltipHideDelay="0">
                                              <span class="autocomplete-option-text">{{ option }}</span>
                                            </mat-option>
                                          }
                                        </mat-autocomplete>
                                        }

                                        @if (dataItem.type === 'String' ) {
                                          <input class="user_summary_matInput" type="text" id="{{dataItem.name}}"
                                            [attr.aria-label]="common.getDispName(dataItem)"
                                            autocomplete="off"
                                            [value]="getUserDataItemValue(dataItem.name, userDataId0)">
                                        }

                                        <!-- 改行可能なテキストボックスを表示 -->
                                        @if (dataItem.type === 'Text' ) {
                                          <textarea class="user_summary_matInput textarea flex-basis-80 textarea-limit"
                                            type="text" id="{{dataItem.name}}"
                                            [attr.aria-label]="common.getDispName(dataItem)"
                                            value="{{getUserDataItemValue(dataItem.name, userDataId0)}}"
                                            rows="5"></textarea>
                                        }

                                        <!-- 数値用テキストボックスを表示 -->
                                        @if (dataItem.type === 'Int' ) {
                                          <input class="user_summary_matInput" type="number" step="1"
                                            id="{{dataItem.name}}" name="{{dataItem.name}}"
                                            [attr.aria-label]="common.getDispName(dataItem)"
                                            placeholder="{{dataItem.min}}〜{{dataItem.max}}"
                                            value="{{getUserDataItemValue(dataItem.name, userDataId0)}}">
                                        }


                                        <!-- 日付け用テキストボックスを表示 -->
                                        @if (dataItem.type === 'Date' ) {
                                          <div class="input-datepicker-container">
                                            <input id="{{dataItem.name}}" class="user_summary_matInput"
                                              [attr.aria-label]="common.getDispName(dataItem)"
                                              [matDatepicker]="userpicker2"
                                              [value]="getFormattedDate(getUserDataItemValue(dataItem.name, userDataId0),'yyyy-mm-dd')"
                                              readonly
                                              (click)="userpicker2.open()" >
                                            <mat-datepicker-toggle matSuffix
                                              [for]="userpicker2" class="custom-icon">
                                              <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                                            </mat-datepicker-toggle>
                                            <mat-datepicker #userpicker2></mat-datepicker>
                                          </div>
                                        }

                                        <!-- True/False のドロップダウンを表示 -->
                                        @if (dataItem.type === 'Bool' ) {
                                          <select id="{{dataItem.name}}" class="input_select"
                                            [attr.aria-label]="common.getDispName(dataItem)">
                                            @if (getUserDataItemValue(dataItem.name, userDataId0).length === 0) {
                                              <option value="" disabled selected i18n="@@home.userSummary.option.notSelected">未選択</option>
                                              <option value="true" i18n="@@home.userSummary.option.yes">あり</option>
                                              <option value="false" i18n="@@home.userSummary.option.no">なし</option>
                                            } @else if (getUserDataItemValue(dataItem.name, userDataId0) === 'あり') {
                                              <option value="true" selected i18n="@@home.userSummary.option.yes">あり</option>
                                              <option value="false" i18n="@@home.userSummary.option.no">なし</option>
                                            } @else {
                                              <option value="true" i18n="@@home.userSummary.option.yes">あり</option>
                                              <option value="false" selected i18n="@@home.userSummary.option.no">なし</option>
                                            }
                                          </select>
                                        }

                                        <!-- ドロップダウンを表示 -->
                                        @if (dataItem.type === 'List' ) {
                                          <select id="{{dataItem.name}}" class="input_select"
                                            [attr.aria-label]="common.getDispName(dataItem)">
                                            @if (getUserDataItemValue(dataItem.name, userDataId0).length !== 0) {
                                              <option value="" i18n="@@home.userSummary.option.notSelected">未選択</option>
                                            } @else {
                                              <option value="" selected i18n="@@home.userSummary.option.notSelected">未選択</option>
                                            }

                                            @for (item of dataItem.values; track $index) {
                                              @if (common.doesListLabelMatch( item, getUserDataItemValue(dataItem.name, userDataId0))) {
                                                <option value="{{ common.getListItemValue(item) }}" selected>
                                                  {{ common.getDispName(item) }}
                                                </option>
                                              } @else {
                                                <option value="{{ common.getListItemValue(item) }}">{{ common.getDispName(item) }}</option>
                                              }
                                            }
                                          </select>
                                        }
                                      </dd>
                                    }
                                }
                              }
                            </dl>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
          }
          <!-- コメント欄のみdl/dtでなく、textareaにて実装 -->
            @if (userDataGroup.name === 'comment' ) {
              <section class="contents__section">
                <div class="user-profile">
                  <div class="user-profile__inner">
                    <div class="data-columns">
                      <div class="data-columns__item">
                        <div class="dl-table">
                          <div class="column_table">
                            @for (dataItem of userDataGroup.dataItems; track dataItem.name) {
                              @if (dataItem.enabled) {
                                <div class="comment-item__label">
                                  <span>{{ common.getDispName(dataItem) }}</span>
                                  @if (mode === modeEnum.input && dataItem.required === true) {
                                    <span class="required-mark">*</span>
                                  }
                                </div>
                                @if (mode === modeEnum.display) {
                                  <div class="comment_display">
                                    <span class="value-text"
                                      [class.value-text--clamped]="!expandedFields()[dataItem.name]"
                                      [attr.data-field]="dataItem.name">{{getUserDataItemValue(dataItem.name, userDataId0)}}</span>
                                    @if (overflowingFields().has(dataItem.name)) {
                                      <button class="value-text__toggle" (click)="toggleFieldExpand(dataItem.name)">
                                        {{ expandedFields()[dataItem.name] ? i18n.button.close : i18n.button.showMore }}
                                      </button>
                                    }
                                  </div>
                                }
                                @if (mode === modeEnum.input) {
                                  @if (dataItem.type === 'Text') {
                                    <textarea class="user_summary_matInput comment-textarea" type="text" id="{{dataItem.name}}"
                                      [attr.aria-label]="common.getDispName(dataItem)"
                                      value="{{getUserDataItemValue(dataItem.name, userDataId0)}}" rows="5"></textarea>
                                  }
                                }
                              }
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            }
            @if (userDataGroup.name === 'KTChart' ) {
              <section class="contents__section">
                <div class="user-profile">
                  <div class="user-profile__inner">
                    <div class="title">
                      <span>{{ common.getDispName(userDataGroup) }}</span>
                    </div>
                    <div class="data-columns">
                      <div class="data-columns__item--half">
                        <!-- レーダーチャート -->
                        <div
                          #chartElement
                          echarts
                          [options]="KTchartOption"
                          [merge]="dynamicData"
                          (chartInit)="onChartInit()"
                          class="radar-chart"
                        >
                        </div>
                      </div>
                      <div class="data-columns__item--half">
                        @for (userDataGroup of selectedSectionGroupUserDataAttributes; track userDataGroup.name) {
                          <!-- レーダーチャートデータ表示 -->
                          @if (userDataGroup.visualizationType === 'RadarChart' ) {
                            <div class="kt-chart-grid">
                              @for (column of getKtChartColumns(userDataGroup.dataItems); track columnIndex; let columnIndex = $index) {
                                <div class="kt-chart-column" data-column-index="{{ columnIndex }}">
                                  @for (entry of column; track entry.item.name) {
                                    @if (entry.item.enabled) {
                                      <div class="kt-chart-item">
                                        <div class="kt-chart-item__label">
                                          <span [matTooltip]="KTChartDiscliptions[entry.index]">{{KTChartDisplay[entry.index]}}</span>
                                          @if (mode === modeEnum.input && entry.item.required === true) {
                                            <span class="required-mark">*</span>
                                          }
                                        </div>
                                        <div class="kt-chart-item__value">
                                          @if (mode === modeEnum.display) {
                                            <span class="kt-chart-item__value-text">
                                              {{getUserDataItemValue(entry.item.name, userDataId0)}}
                                              <span [class]="getArrowColor(entry.item.name, userDataId0, userDataId1)">
                                                ({{getUserDataItemValueComparewithArrow(entry.item.name, userDataId0, userDataId1)}})
                                              </span>
                                            </span>
                                          }
                                          @if (mode === modeEnum.input) {
                                            @if (entry.item.type === 'String' ) {
                                              <input class="user_summary_matInput" type="text" id="{{entry.item.name}}"
                                                [attr.aria-label]="KTChartDisplay[entry.index]"
                                                value="{{getUserDataItemValue(entry.item.name, userDataId0)}}">
                                            }
                                            @if (entry.item.type === 'Text' ) {
                                              <textarea class="user_summary_matInput textarea flex-basis-80" type="text"
                                                id="{{entry.item.name}}"
                                                [attr.aria-label]="KTChartDisplay[entry.index]"
                                                value="{{getUserDataItemValue(entry.item.name, userDataId0)}}"
                                                rows="5"></textarea>
                                            }
                                            @if (entry.item.type === 'Int' ) {
                                              <input class="user_summary_matInput" type="number" step="1"
                                                id="{{entry.item.name}}" name="{{entry.item.name}}"
                                                [attr.aria-label]="KTChartDisplay[entry.index]"
                                                placeholder="{{entry.item.min}}〜{{entry.item.max}}"
                                                value="{{getUserDataItemValue(entry.item.name, userDataId0)}}">
                                            }
                                            @if (entry.item.type === 'Bool' ) {
                                              <select id="{{entry.item.name}}" class="input_select"
                                                [attr.aria-label]="KTChartDisplay[entry.index]">
                                                @if (getUserDataItemValue(entry.item.name, userDataId0).length === 0) {
                                                  <option value="" disabled selected i18n="@@home.userSummary.option.notSelected">未選択</option>
                                                  <option value="true" i18n="@@home.userSummary.option.yes">あり</option>
                                                  <option value="false" i18n="@@home.userSummary.option.no">なし</option>
                                                } @else if (getUserDataItemValue(entry.item.name, userDataId0) === 'あり') {
                                                  <option value="true" selected i18n="@@home.userSummary.option.yes">あり</option>
                                                  <option value="false" i18n="@@home.userSummary.option.no">なし</option>
                                                } @else {
                                                  <option value="true" i18n="@@home.userSummary.option.yes">あり</option>
                                                  <option value="false" selected i18n="@@home.userSummary.option.no">なし</option>
                                                }
                                              </select>
                                            }
                                            @if (entry.item.type === 'List' ) {
                                              <select id="{{entry.item.name}}" class="input_select"
                                                [attr.aria-label]="KTChartDisplay[entry.index]">
                                                @if (getUserDataItemValue(entry.item.name, userDataId0).length !== 0) {
                                                  <option value="" i18n="@@home.userSummary.option.notSelected">未選択</option>
                                                } @else {
                                                  <option value="" selected i18n="@@home.userSummary.option.notSelected">未選択</option>
                                                }
                                                @for (item of entry.item.values; track $index) {
                                                  @if (common.doesListLabelMatch(item, getUserDataItemValue(entry.item.name, userDataId0))) {
                                                    <option value="{{ common.getListItemValue(item) }}" selected>
                                                      {{ common.getDispName(item) }}
                                                    </option>
                                                  } @else {
                                                    <option value="{{ common.getListItemValue(item) }}">{{ common.getDispName(item) }}</option>
                                                  }
                                                }
                                              </select>
                                            }
                                          }
                                        </div>
                                      </div>
                                    }
                                  }
                                </div>
                              }
                            </div>
                          }
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            }
          }
        }

    </div>
  </div>
</div>

<div class="padding-for-fixed-sections" [class.padding-for-fixed-sections--expanded]="isPdfOptionsExpanded"></div>
